/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
// import GrocedySettingTable  from './GrocedySettingTable';
import { GetFeatureListAtom, SetFeatureListAtom } from "../../store/actionUrlAtom";
import { Link } from "react-router-dom";

import { useNavigate, useParams, useLocation } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import RestartAlt from "@mui/icons-material/RestartAlt";
import { settingsService } from "../../services/settingsService";
import GeneralCustomTable from "../../helpers/GeneralCustomTable";



const columns = [
  {
    title: 'ID',
    key: 'Feature_Action_URL_Id',
    dataIndex: 'Feature_Action_URL_Id',
  className: "text-sn",
  sorter: (a, b) => (a?.Feature_Action_URL_Id ?? '') - (b?.Feature_Action_URL_Id ?? '')
  },

  {
    title: 'Feature_Action_URL_Name',
    // key: 'id',
    dataIndex: 'Feature_Action_URL_Name',
  className: "text-primary font-bold",
  sorter: (a, b) => (a?.Feature_Action_URL_Name ?? '').localeCompare(b?.Feature_Action_URL_Name ?? '')

  },
    
  {
    title: "Action Web Url",
    dataIndex: "Feature_Action_URL_Web",
    sorter: (a, b) => (a?.Feature_Action_URL_Web ?? '').localeCompare(b?.Feature_Action_URL_Web ?? '')

  },

  {
    title: "Mobile Web Url",
    dataIndex: "Feature_Action_URL_Mobile",
    sorter: (a, b) => (a?.Feature_Action_URL_Mobile ?? '').localeCompare(b?.Feature_Action_URL_Mobile ?? '')

  },
  {
    title: "Status",
    dataIndex: "Feature_Action_Status_Name",
    sorter: (a, b) => (a?.Feature_Action_Status_Name ?? '').localeCompare(b?.Feature_Action_Status_Name ?? '')

  },

];




const FeatureActionUrlMainPage = () => {
    const getFeatureList = GetFeatureListAtom();
    const setFeatureList = SetFeatureListAtom();
    const navigate = useNavigate();
    const { pathname } = useLocation();  
    var url = pathname.split('/')
    const currModuleId = url[1];
    const currModuleName = url[2];
    const currUserMenu = url[3];


  useEffect(() => {
    if (getFeatureList.length < 1) {
      loadDataFromServer();
    }
  }, [getFeatureList.length]);



  const loadDataFromServer = () => {
    settingsService.getHomePageFeature().then(res => {
      if (res?.data?.length) {
        setFeatureList(res.data);
      }
    });
  }



  const addNewMenu = () => {
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`);
  }

  function handleRowClick(action) {
    const id = action['Feature_Action_URL_Id'];
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${id}`);
}



  return (
    <>
      <div className=" b">
        <section className="">




          <div className="flex justify-between w-full  "  >
            <Tooltip title="Reload">
              <RestartAlt
                className="cursor ml-2 mt-1"
                onClick={() => loadDataFromServer()}
                color="primary"
                fontSize="large"
              />
            </Tooltip>
            <button
              onClick={() => addNewMenu()}
              style={{ backgroundColor: "#476EF8" }}
              className="  rounded text-white text-sm font-[Poppins] mt-1 py-2  px-3"
            >
              Add New
            </button>
          </div>



          <section className="mt-5">

            <GeneralCustomTable
                tableHeadList={columns} 
                tableDataList={getFeatureList}
                allowCheckBox={false} // show checkBox for each row
                setSelectedRows={()=>console.log('') }
                rowKey={(record) => record.Feature_Action_URL_Id} // custom key
                handleRowClick={handleRowClick} />

            </section>
        </section>
      </div>


    </>
  );
}
 
export default FeatureActionUrlMainPage;
